import { render, staticRenderFns } from "./setStatisticalClassifi.vue?vue&type=template&id=7f5b7834&scoped=true"
import script from "./setStatisticalClassifi.vue?vue&type=script&lang=js"
export * from "./setStatisticalClassifi.vue?vue&type=script&lang=js"
import style0 from "./setStatisticalClassifi.vue?vue&type=style&index=0&id=7f5b7834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b7834",
  null
  
)

export default component.exports